"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRowWidth = setRowWidth;
exports.onRowDrag = onRowDrag;
exports.getCustomCellRenderer = getCustomCellRenderer;
exports.transformOldTableData = void 0;

var _cloneDeep = _interopRequireDefault(require("lodash/cloneDeep"));

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var transformOldTableData = function transformOldTableData(headers) {
  return headers.map(function (column) {
    var transformedColumn = (0, _cloneDeep["default"])(column);
    transformedColumn.field = column.name;
    transformedColumn.headerName = column.title;
    transformedColumn.rendererType = column.type;
    transformedColumn.hide = column.hideColumn;
    delete transformedColumn.type;
    var specialWidth = column.alignRight ? column.title.length * 9 + 'px' : column.width ? column.width : 'auto';
    var columnColor = column.columnColor ? column.columnColor : 'inherit';
    var fontColor = column.fontColor ? column.fontColor : 'inherit';
    transformedColumn.cellStyle = {
      width: specialWidth,
      backgroundColor: columnColor,
      color: fontColor
    };
    transformedColumn.cellClass = [column.className];

    if ((0, _isBoolean["default"])(column.alignRight) && column.alignRight) {
      transformedColumn.cellClass.push('text-align-right');
    }

    if ((0, _isBoolean["default"])(column.detailClickable) && !column.detailClickable || column.disableRouteClick) {
      transformedColumn.cellClass.push('no-pointer');
    }

    transformedColumn.cellRenderer = getCustomCellRenderer(transformedColumn);

    if (transformedColumn.tooltip) {
      var text = transformedColumn.tooltip.text;

      transformedColumn.tooltipValueGetter = function (params) {
        return text || params.value;
      };

      delete transformedColumn.tooltip;
    }

    return transformedColumn;
  }).filter(function (o) {
    return o !== undefined;
  });
};

exports.transformOldTableData = transformOldTableData;

function setRowWidth(gridWidth) {
  var nonScrollableElement = window.document.getElementsByClassName('ag-center-cols-container');
  var nonScrollableWidth = nonScrollableElement.length && nonScrollableElement[0].offsetWidth;

  if (gridWidth > nonScrollableWidth && nonScrollableElement[0]) {
    nonScrollableElement[0].setAttribute('style', "width: ".concat(gridWidth, "px!important"));
  }
}

function onRowDrag(params) {
  var rowNode = params.rowNode;
  var e = params.dragEvent;
  var jsonObject = {
    grid: "PRODUCT_TABLE",
    operation: "Drag on Column",
    row: rowNode.data
  };
  var jsonData = JSON.stringify(jsonObject);
  var userAgent = window.navigator.userAgent;
  var isIE = userAgent.indexOf("Trident/") >= 0;

  if (isIE) {
    e.dataTransfer.setData("text", jsonData);
  } else {
    e.dataTransfer.setData("application/json", jsonData);
    e.dataTransfer.setData("text/plain", jsonData);
  }
}

function getCustomCellRenderer(col) {
  switch (col.rendererType) {
    case 'dragdrop':
      return 'dragDropFormat';

    case 'checkbox':
      return 'checkboxFormat';

    case 'checkboxDisabled':
      return 'checkboxDisableFormat';

    case 'date':
      return 'dateFormat';

    case 'dateTime':
      return 'dateTimeFormat';

    case 'image':
      return 'displayImage';

    case 'icon':
      return 'iconFormat';

    case 'editField':
      return 'editFieldFormat';

    case 'buttonField':
      return 'buttonFieldFormat';

    case 'dangerouslyDisplayRawHTML':
      return 'dangerouslyDisplayRawHTML';

    case 'price':
      return 'priceFormat';

    case 'calcTotalPrice':
      return 'priceFormatTotal';

    case 'calcpricepercentage':
      return 'calcPricePercentageFormat';

    case 'percentage':
      return 'percentageFormat';

    case 'imageCheckDescription':
      return 'displayImageCheckDescriptionFormat';

    case 'commaSeparate':
      return 'commaSeparateFormat';

    case 'visible':
      return 'visibleFormat';

    case 'kebab':
      return 'getKebabFormat';

    case 'tags':
      return 'tagsFormat';

    case 'colorType':
      return 'displayBackgroundColor';

    case 'concatted':
      return 'concatFormat';

    case 'localList':
      return 'localListFormat';

    case 'message':
      return 'messageFormat';

    case 'url':
      return 'urlFormat';

    case 'category':
      return 'getCategories';

    case 'dragRightView':
      return 'dragRightView';

    default:
      return 'getDefault';
  }
}